import React from "react";
import _ from "lodash";
import moment from "moment";

import styles from "./BillingInformationSettings.module.scss";
import FormHeading from "../../../atoms/FormHeading/FormHeading";
import { Button } from "@blueprintjs/core";
import { FormRow } from "../../../atoms/FormRow";
import { toPascalCase } from "../../../helpers/utils";

export function CurrentBillingPackage({
  subscriptionPlan,
  fixedFee,
  variableFee,
  changePlan,
  currentPeriodEnd,
  isTrial,
  setChangePlan
}) {
  const {
    nickname,
    amount,
    transactionVolumeLimit,
    videoLimit,
    opportunityLimit
  } = subscriptionPlan;

  return (
    <>
      <div className={styles.row}>
        <div className={styles.headingHolder}>
          <FormHeading className={styles.heading} weight="600">
            Current Package
          </FormHeading>
        </div>

        {!changePlan && (
          <div className={styles.buttonHolder}>
            <Button
              text="Change Plan"
              intent="Primary"
              onClick={() => {
                setChangePlan(true);
              }}
            />
          </div>
        )}
      </div>
      <FormRow>
        <div className={styles.planInfoCard}>
          <div className={styles.header}>
            <div className={styles.planInfo}>
              <div className={styles.planName}>
                {toPascalCase(nickname).replace(" ", "-")}{" "}
                {isTrial && `$${amount}/month`}
              </div>
              <div className={styles.renewDate}>
                Renews {moment(currentPeriodEnd).format("MMMM Do, YYYY")}
              </div>
            </div>
            {isTrial ? (
              <div className={styles.planPrice}>
                <span className={styles.price}>Free Trial</span>
              </div>
            ) : (
              <div className={styles.planPrice}>
                <span className={styles.price}>${amount}</span>
                /month
              </div>
            )}
          </div>
          <div className={styles.contentHolder}>
            <div className={styles.col}>
              <div className={styles.stats}>
                {transactionVolumeLimit == 0
                  ? "Unlimited"
                  : `$${transactionVolumeLimit}`}
              </div>
              <div className={styles.statsName}>Monthly Volume</div>
            </div>
            <div className={styles.col}>
              <div className={styles.stats}>
                {videoLimit == 0 ? "Unlimited" : videoLimit}
              </div>
              <div className={styles.statsName}>Videos</div>
            </div>
            <div className={styles.col}>
              <div className={styles.stats}>
                {opportunityLimit == 0 ? "Unlimited" : opportunityLimit}
              </div>
              <div className={styles.statsName}>Opportunities</div>
            </div>
            <div className={styles.col}>
              <div className={styles.stats}>
                {variableFee}% + {fixedFee}c
              </div>
              <div className={styles.statsName}>Transaction Fee</div>
            </div>
          </div>
        </div>
      </FormRow>
    </>
  );
}
